'use client';
import { useRef, useState } from 'react';
import { tv } from 'tailwind-variants';
import { useRectTracker } from '../../_lib/useRectTracker';
import { useRouter, useParams } from 'next/navigation';
import { IconResolver } from '../../IconResolver';
import { SearchInput } from '../../Search';

const styles = tv({
	slots: {
		base: 'relative h-[2.5rem] transition-colors duration-400 ease-smooth cursor-pointer flex items-center  disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed',
		input:
			'w-full bg-transparent transition-colors duration-400 ease-smooth cursor-pointer text-grey-60 focus:text-primary focus:outline-none focus:ring-0',
		icon: 'p-3 text-foreground-tertiary',
		closeButton: 'absolute top-1/2 right-0 -translate-y-1/2 hover:text-foreground-tertiary',
	},
	variants: {
		showInput: {
			true: {
				base: 'bg-background-tertiary',
			},
			false: { base: 'aspect-square bg-transparent hover:bg-background-tertiary' },
		},
		hasValue: {
			true: {
				closeButton: 'block',
			},
			false: { closeButton: 'hidden' },
		},
	},
});

export function GlobalNavSearch() {
	const windowWidth = useRectTracker().windowWidth;
	const [hasValue, setHasValue] = useState(false);
	const [showInput, setShowInput] = useState(false);
	const router = useRouter();
	const params = useParams();
	const locale = 'locale' in params ? params.locale : 'path' in params && Array.isArray(params.path) ? params.path[0] : null;

	const { base, icon, closeButton } = styles({ showInput, hasValue });

	const inputRef = useRef<HTMLInputElement>(null);

	if (windowWidth > 0 && windowWidth < 1024 && !showInput) setShowInput(true);

	const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setHasValue(false);
		if (inputRef.current && inputRef.current.value.trim()) {
			const query = encodeURIComponent(inputRef.current.value.trim());
			router.push(`/${locale}/search?query=${query}`);
			setShowInput(false);
		}
	};

	return (
		<div>
			<form onSubmit={handleSearchSubmit} className={`${base()} focus:outline-none focus:ring-0 border-none`}>
				<div className={`${icon()}`} onClick={() => setShowInput(true)}>
					<IconResolver icon='magnifying-glass' className='w-[1rem] h-[1rem]' />
				</div>
				<SearchInput
					className={`py-3 px-2 w-full`}
					hasValue={hasValue}
					autoComplete='off'
					autoCorrect='off'
					autoCapitalize='off'
					spellCheck={false}
					ref={inputRef}
					placeholder='Search'
					id='global-nav-search'
					name='global-nav-search'
					results={[]}
					onBlur={() => {
						if (!hasValue) setTimeout(() => setShowInput(false), 600);
					}}
					onChange={e => {
						setHasValue(e.target.value.length > 0);
					}}
				/>
			</form>
		</div>
	);
}
